import React from 'react';
import Link from '@atlaskit/link';
import { FormattedMessage } from 'react-intl';

export const COOKIE_SETTINGS_HELP_URL =
  'https://support.atlassian.com/atlassian-account/docs/login-issues-related-to-browser-cookies/';

/**
 * Shown when signup is blocked because the request has no anonymous ID, on all
 * three signup surfaces (password signup, onboard signup, social confirmation).
 */
export function CookieMissingErrorMessage() {
  return (
    <FormattedMessage
      id="common.error.cookie.missing.browser.settings"
      defaultMessage="We’re unable to create your account at this time. Please make sure strictly necessary cookies are enabled in your <browser-settings-link>browser settings</browser-settings-link>."
      values={{
        'browser-settings-link': (chunks: React.ReactNode) => (
          <Link
            href={COOKIE_SETTINGS_HELP_URL}
            target="_blank"
            // https://mathiasbynens.github.io/rel-noopener
            rel="noopener noreferrer">
            {chunks}
          </Link>
        ),
      }}
    />
  );
}
